<template>
  <el-select class="width-100" :multiple="limit > 1" :multiple-limit="limit" value-key="link" :value="value" @change="onChange" placeholder="固定ページから選択">
    <template v-for="page in publishedPages">
      <el-option class="el-opp"
        :key="page.link"
        :label="page.title.rendered"
        :value="page.id">
      </el-option>
    </template>
  </el-select>
</template>

<script>
export default {
  name: 'select-links',
  props: {
    value: {
      type: Array
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  computed: {
    pages: {
      get () { return this.$store.getters['wordpress/pages/all'] }
    },
    publishedPages: {
      get () { return this.$store.getters['wordpress/pages/published'] }
    }
  },
  methods: {
    onChange: function (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<docs>
# select-links

## summary

el-selectをラップして固定ページから選択できるようにするコンポーネント

## usage

```
<select-links :limit="6" v-model="contents.menuIds"></select-links>
```

</docs>


// WEBPACK FOOTER //
// src/components/forms/SelectLinks.vue